import { HttpErrorResponse } from '@angular/common/http';
import {
  Component,
  inject,
  ElementRef,
  Injector,
  OnInit,
  OnDestroy,
  ViewEncapsulation,
  input,
  output,
  effect,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ɵSharedStylesHost } from '@angular/platform-browser';
import { Router, RouterModule } from '@angular/router';
import { LoadingComponent } from '@esp-enrollment-form/shared-ui';
import {
  LoggerService,
  SharedDataService,
  SuccessDisplayService,
} from '@esp-enrollment-form/shared-utils';
import { ErrorDisplayService } from '@esp-enrollment-form/shared-utils';
import { environment } from '@esp-enrollment-form/shared-utils';
import { Subject } from 'rxjs';

import { CompassCalloutModule } from '@pwc/compass/callout';

import { APP_SELECTOR } from './app.config-constants';

@Component({
  imports: [RouterModule, CompassCalloutModule, LoadingComponent],
  selector: APP_SELECTOR,
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  encapsulation: ViewEncapsulation.ShadowDom,
})
export class AppComponent implements OnInit, OnDestroy {
  readonly #loggerService = inject(LoggerService);
  private readonly _router = inject(Router);
  private readonly _injector = inject(Injector);
  private readonly _sharedDataService = inject(SharedDataService);
  private readonly _errorDisplay = inject(ErrorDisplayService);
  private readonly _successDisplay = inject(SuccessDisplayService);
  private destroy$ = new Subject<void>();
  transactionid = input<string | undefined>();
  userbadge = input<string | undefined>();
  customercode = input<string | undefined>();
  customeremail = input<string | undefined>();
  firstname = input<string | undefined>();
  lastname = input<string | undefined>();
  token = input<string | undefined>();
  errorEvent = output<{ error: Error | HttpErrorResponse }>();

  showErrorMessage = this._errorDisplay.showErrorMessage;
  errorMessageText = this._errorDisplay.errorMessageText;
  showSuccessMessage = this._successDisplay.showSuccessMessage;
  elementRef = inject(ElementRef);

  constructor() {
    this._injector.get(ɵSharedStylesHost).removeHost(document.head);

    this.#loggerService.errorEvent$
      .pipe(takeUntilDestroyed())
      .subscribe((error) => this.errorEvent.emit({ error }));

    effect(() => {
      const token = this.token();
      if (token) {
        this._sharedDataService.token.set(token);
      }
    });
  }

  ngOnInit() {
    this._router.initialNavigation();
    this.#loggerService.updateConfiguration({
      transactionId: this.transactionid(),
    });

    const root = (this.elementRef.nativeElement as HTMLElement).shadowRoot;

    if (root) {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = `${environment.assetsUrl}/styles.css`;
      root.prepend(link);
    }

    this._sharedDataService.setUserDetails(
      this.userbadge(),
      this.customercode(),
      this.customeremail(),
      this.firstname(),
      this.lastname(),
    );
  }
  ngOnDestroy() {
    // Clean up all subscriptions
    this.destroy$.next();
    this.destroy$.complete();
  }
}
